import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { UpdateProfileRequest, User } from "@/api/types";
import { assertCurrentSession, sessionRevision } from "@/lib/session-request-scope";

export function useUpdateProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateProfileRequest) => api.patch("me", { json: data }).json<User>(),
    onSuccess: async (data) => {
      const revision = sessionRevision();
      await queryClient.cancelQueries({ queryKey: ["me"], exact: true });
      assertCurrentSession(revision);
      queryClient.setQueryData<User | null>(["me"], (user) =>
        user?.id === data.id
          ? {
              ...user,
              first_name: data.first_name,
              last_name: data.last_name,
              display_name: data.display_name,
              terms_accepted_at: data.terms_accepted_at,
            }
          : user,
      );
    },
  });
}
